import { GetServerSideProps } from 'next';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import DiscountLandingWrapper from '@/components/discountLanding/DiscountLandingWrapper';
import Layout from '@/components/layout/LayoutWrapper';
import { useLoginForm } from '@/hooks/forms';
import { useUserState } from '@/hooks/store';
import messages from '@/messages/messages';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';
import { userCanTrial } from '@/utils/subscriptions';

const NewMemberOfferPage = () => {
	const { formatMessage } = useIntl();
	const user = useUserState();
	const { onLogout } = useLoginForm();
	const searchParams = useSearchParams();
	const email = searchParams?.get('email');

	useEffect(() => {
		// check if email param matches logged in user (only on first load)
		if (user?.email && email && user.email !== email) {
			onLogout();
		}
	}, [onLogout, email, user]);

	return (
		<Layout pageName="calm-annual-offer" title={`Calm - ${formatMessage(messages.newMemberOfferTitle)}`}>
			<DiscountLandingWrapper />
		</Layout>
	);
};

export default NewMemberOfferPage;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	if (initialState && !userCanTrial(initialState.user)) {
		return {
			redirect: {
				permanent: false,
				destination: '/special-welcome-offer',
			},
		};
	}

	return {
		props: {
			initialState: {
				...initialState,
				theme: {
					webAppLayout: null,
					header: 'dark',
				},
			},
		},
	};
};
